import React from 'react'
import PropTypes from 'prop-types'
import {Divider, Text} from '@chakra-ui/react'

const WarrantyHeader = ({children}) => {
    return (
        <>
            <Text as="h1" textStyle="Regular 2XLarge" textAlign="center">
                {children}
            </Text>

            <Divider colorScheme="stokkeGray" />
        </>
    )
}

WarrantyHeader.propTypes = {
    children: PropTypes.node.isRequired
}

export default WarrantyHeader
